import { EMAIL_PLACEHOLDER_TAGS } from 'features/EmailEditor/constants'
import PropTypes from 'prop-types'

import styles from './EmailEditor.module.scss'

const EmailTagButtons = ({ onInsert }) => (
  <div className={styles.tagButtons}>
    {EMAIL_PLACEHOLDER_TAGS.map(tag => (
      <button
        key={tag.placeholder}
        type="button"
        className={styles.tagButton}
        title={`Insert ${tag.placeholder}`}
        // Keeps the caret in the field so the tag lands where the user left it.
        onMouseDown={event => event.preventDefault()}
        onClick={() => onInsert(tag.placeholder)}
      >
        {tag.label}
      </button>
    ))}
  </div>
)

EmailTagButtons.propTypes = {
  onInsert: PropTypes.func.isRequired
}

export default EmailTagButtons
